import apiClient from "../config/api";
import { getUserId, getWorkshopId } from "../config/constants";

const resolveContext = (workshopId) => {
    const userId = getUserId();
    const effectiveWorkshopId = workshopId || getWorkshopId();

    if (!userId) throw new Error("Usuario no identificado");
    if (!effectiveWorkshopId) throw new Error("Taller no seleccionado");

    return { userId, workshopId: effectiveWorkshopId };
};

export const carService = {
    async getVehicleHistory(vehicleId, workshopId) {
        const ctx = resolveContext(workshopId);
        const response = await apiClient.get(
            `/${ctx.workshopId}/history/${vehicleId}`,
        );
        return response.data;
    },

    async getClientVehicles(clientId, workshopId) {
        const ctx = resolveContext(workshopId);
        const response = await apiClient.get(
            `/${ctx.workshopId}/cars/${clientId}`,
        );
        return response.data;
    },

    async getCarById(carId, workshopId) {
        const ctx = resolveContext(workshopId);
        const response = await apiClient.get(
            `/${ctx.workshopId}/car/${carId}`,
        );
        return response.data;
    },

    async createVehicle(payload, workshopId) {
        const ctx = resolveContext(workshopId);
        const response = await apiClient.post(
            `/${ctx.workshopId}/car`,
            payload,
        );
        return response.data;
    },

    async updateVehicle(carId, payload, workshopId) {
        const ctx = resolveContext(workshopId);
        const response = await apiClient.put(
            `/${ctx.workshopId}/car/${carId}`,
            { data: payload }
        );
        return response.data;
    },

    async deleteVehicle(carId, workshopId) {
        const ctx = resolveContext(workshopId);
        const response = await apiClient.delete(
            `/${ctx.workshopId}/car/${carId}`,
        );
        return response.data;
    },
};
